module.exports = __webpack_public_path__ + "img/user-illustarator-1.d5f3e4d9.png";